// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.travel-title {
    font-size: 5rem;
    color: white;
    margin: 3rem 0;
    text-align: center;
    margin-top: 5%;
    letter-spacing: 0.3rem;
    padding-bottom: 4rem;
    overflow: hidden;
}

.travel-img {
    height: 100%;
    object-fit: cover;
    transition: transform .4s;
    width: 100%;
    filter: grayscale(100%);
}

.travel-img-container:hover img {
    transform: scale(1.2, 1.2);
    transition: transform 6s;
    filter: none;
}

.travel-img-container.inverted {
    transform: rotate(-3deg);
}

.travel-img-container {
    border: solid #FFF 10px;
    margin: auto;
    width: 376px;
    height: 251px;
    overflow: hidden;
    transform: rotate(3deg);
    box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    position: relative;
    top: 50px;
    /* Add a top position to create staggered effect */
    left: -20px;
    /* Add a left position to create staggered effect */
}

.travel-img-container.inverted {
    transform: rotate(-3deg);
    top: -50px;
    /* Adjust top position for inverted elements */
    left: 20px;
    /* Adjust left position for inverted elements */
}

.travel-container {
    overflow: hidden;
    padding-bottom: 20rem;
}

.travel-img-container .travel-vid {
    height: 100%;
    object-fit: cover;
    transition: transform .4s;
    width: 100%;
    filter: grayscale(100%);
}

.travel-img-container:hover .travel-vid {
    transform: scale(1.2, 1.2);
    transition: transform 6s;
    filter: none;
}

.travel-img-columns {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.travel-left-column {
    margin-left: 0;
    flex: 1 1;
}

.travel-right-column {
    flex: 1 1;
    height: 100vh;
}

.travel-right-column {
    flex: 1 1;
    position: relative;
    font-size: 5rem;
    color: white;
}

@media (min-width: 1400px) {
    .top-text {
        position: absolute;
        width: 100%;
        text-align: center;
    }

    .top-middle-text {
        position: absolute;
        top: 30%;
        left: 0%;
        width: 100%;
        text-align: center;
    }

    .middle-text {
        position: absolute;
        top: 50%;
        left: 10%;
        width: 100%;
        text-align: center;
    }

    .bottom-middle-text {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
        text-align: center;
    }


    .bottom-text {
        position: absolute;
        bottom: 0;
        left: 30%;
        transform: translateX(-50%);
        width: 50%;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Travel.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,kDAAkD;IAClD,kBAAkB;IAClB,SAAS;IACT,kDAAkD;IAClD,WAAW;IACX,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,8CAA8C;IAC9C,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,SAAO;AACX;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,kBAAkB;IACtB;;;IAGA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":[".travel-title {\n    font-size: 5rem;\n    color: white;\n    margin: 3rem 0;\n    text-align: center;\n    margin-top: 5%;\n    letter-spacing: 0.3rem;\n    padding-bottom: 4rem;\n    overflow: hidden;\n}\n\n.travel-img {\n    height: 100%;\n    object-fit: cover;\n    transition: transform .4s;\n    width: 100%;\n    filter: grayscale(100%);\n}\n\n.travel-img-container:hover img {\n    transform: scale(1.2, 1.2);\n    transition: transform 6s;\n    filter: none;\n}\n\n.travel-img-container.inverted {\n    transform: rotate(-3deg);\n}\n\n.travel-img-container {\n    border: solid #FFF 10px;\n    margin: auto;\n    width: 376px;\n    height: 251px;\n    overflow: hidden;\n    transform: rotate(3deg);\n    box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);\n    position: relative;\n    top: 50px;\n    /* Add a top position to create staggered effect */\n    left: -20px;\n    /* Add a left position to create staggered effect */\n}\n\n.travel-img-container.inverted {\n    transform: rotate(-3deg);\n    top: -50px;\n    /* Adjust top position for inverted elements */\n    left: 20px;\n    /* Adjust left position for inverted elements */\n}\n\n.travel-container {\n    overflow: hidden;\n    padding-bottom: 20rem;\n}\n\n.travel-img-container .travel-vid {\n    height: 100%;\n    object-fit: cover;\n    transition: transform .4s;\n    width: 100%;\n    filter: grayscale(100%);\n}\n\n.travel-img-container:hover .travel-vid {\n    transform: scale(1.2, 1.2);\n    transition: transform 6s;\n    filter: none;\n}\n\n.travel-img-columns {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n}\n\n.travel-left-column {\n    margin-left: 0;\n    flex: 1;\n}\n\n.travel-right-column {\n    flex: 1;\n    height: 100vh;\n}\n\n.travel-right-column {\n    flex: 1;\n    position: relative;\n    font-size: 5rem;\n    color: white;\n}\n\n@media (min-width: 1400px) {\n    .top-text {\n        position: absolute;\n        width: 100%;\n        text-align: center;\n    }\n\n    .top-middle-text {\n        position: absolute;\n        top: 30%;\n        left: 0%;\n        width: 100%;\n        text-align: center;\n    }\n\n    .middle-text {\n        position: absolute;\n        top: 50%;\n        left: 10%;\n        width: 100%;\n        text-align: center;\n    }\n\n    .bottom-middle-text {\n        position: absolute;\n        bottom: 20%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 50%;\n        text-align: center;\n    }\n\n\n    .bottom-text {\n        position: absolute;\n        bottom: 0;\n        left: 30%;\n        transform: translateX(-50%);\n        width: 50%;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
